import { useLocation, useSearchParams } from 'react-router'
import { Domain, HomeOutlined } from '@mui/icons-material'
import ChevronRight from '@mui/icons-material/ChevronRight'
import { useTheme } from '@mui/material'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

import StatusChip from '../../../components/status-chip'
import { formatAddress } from '../../../utils/helpers'
import useSharedStyles from '../../../utils/shared.styles'
import useStyles from '../index.styles'

const AccountDetails = ({
  folder,
  folderAttributes,
  folderTheme,
}: {
  folder: IFolderType
  folderAttributes: IFolderAttributesType | undefined
  folderTheme: IFolderTheme | undefined
}) => {
  const classes = useStyles
  const sharedClasses = useSharedStyles
  const theme = useTheme()

  const [, setSearchParams] = useSearchParams()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const tab = params.get('tab')

  const addressIconSx = { color: theme.palette.surface.variant3 }

  return (
    <>
      <Grid container={true} sx={[sharedClasses.centerContentVertical, { gap: '4px', mt: 1 }]}>
        {folderTheme?.locationType === 'Commercial Lines' ? (
          <Domain sx={addressIconSx} />
        ) : folderTheme?.locationType === 'Personal Lines' ? (
          <HomeOutlined sx={addressIconSx} />
        ) : null}
        <Typography variant="body2" className="fs-exclude">
          {formatAddress(folder.information.address)}
        </Typography>
      </Grid>
      <Grid container={true} sx={{ flexDirection: 'column' }}>
        <Grid container={true} size={12} sx={[sharedClasses.centerContentVertical, { gap: 6, paddingTop: 2, paddingBottom: 1 }]}>
          {folderAttributes?.accountStatus && (
            <Grid container={true} sx={{ flexDirection: 'column', gap: '2px' }}>
              <Grid>
                <Typography variant="caption">Status</Typography>
              </Grid>
              <Grid>
                {folderAttributes.accountStatus === 'Active' && <StatusChip size="small" label="Active" status="active" />}
                {folderAttributes.accountStatus === 'Inactive' && <StatusChip size="small" label="Inactive" status="inactive" />}
                {folderAttributes.accountStatus === 'Not Activated' && <StatusChip size="small" label="Not Activated" status="not activated" />}
              </Grid>
            </Grid>
          )}

          {folderAttributes?.clientAccountNumber && (
            <Grid container={true} sx={{ flexDirection: 'column', gap: '2px' }}>
              <Grid>
                <Typography variant="caption">Acct#</Typography>
              </Grid>
              <Grid>
                <Typography variant="body2" className="fs-exclude">
                  {folderAttributes.clientAccountNumber}
                </Typography>
              </Grid>
            </Grid>
          )}

          {folderTheme?.locationType && (
            <Grid container={true} sx={{ flexDirection: 'column', gap: '2px' }}>
              <Grid>
                <Typography variant="caption">Acct. Type</Typography>
              </Grid>
              <Grid>
                <Typography variant="body2">{folderTheme.locationType}</Typography>
              </Grid>
            </Grid>
          )}

          {folderTheme?.supportLevel && (
            <Grid container={true} sx={{ flexDirection: 'column', gap: '2px' }}>
              <Grid>
                <Typography variant="caption">Support</Typography>
              </Grid>
              <Grid>
                <Typography variant="body2">{folderTheme.supportLevel}</Typography>
              </Grid>
            </Grid>
          )}

          {tab !== 'about' && (
            <Grid container={true} sx={{ flexDirection: 'column', gap: '2px' }}>
              <Grid>&nbsp;</Grid>
              <Grid>
                <Button onClick={() => setSearchParams({ tab: 'about' })} endIcon={<ChevronRight />} sx={classes.accountViewMoreAbout}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: '600',
                    }}
                  >
                    More about this location
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default AccountDetails
